import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

// import * as ValidatorModule from 'validatorjs';

// import en from 'validatorjs/src/lang/en';
Alpine.plugin(collapse)

document.addEventListener('alpine:init', () => {
  const countrySlider = document.querySelectorAll('.countries-swiper');
  const countrySwiper = [];

  for (let i = 0; i < countrySlider.length; i++) {
    const slider = countrySlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-countries');
      const prevBtn = parent.querySelector('.swiper-button-prev-countries');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-countries-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-countries-' + i);

      countrySwiper[i] = new Swiper('.swiper-container-' + i, {
        // init: false, // Stop it from running immediately
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: 3.3,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar-" + i,
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-countries-" + i,
          prevEl: ".swiper-button-prev-countries-" + i,
        },
        on: {
          slideChange: function () {
            // Only trigger if screen is smaller than 640px (your breakpoint)
            if (window.innerWidth < 640) {
              // 1. Get the current active slide element
              const activeSlide = this.slides[this.activeIndex];

              // 2. Extract the attribute
              const countryCode = activeSlide.getAttribute('data-country-code');

              // 3. Use the data
              // console.log('Active Country Code on Mobile:', countryCode);

              // Example: If you want to update an Alpine.js variable
              window.dispatchEvent(new CustomEvent('region-focus', { 
                detail: { code: countryCode } 
              }));
            }
          },
          // init: function () {
          //   console.log("Hello");
          //   const firstSlide = this.slides[0];
          //   const countryCode = firstSlide.getAttribute('data-country-code');
          //   console.log(countryCode);
          //   window.dispatchEvent(new CustomEvent('region-focus', { 
          //     detail: { code: countryCode } 
          //   }));
          // },
      },
      });
    }
    setTimeout(() => {
      // Only fire if the screen width is 768px or less
      if (window.matchMedia("(max-width: 768px)").matches) {
        
        const initialCode = countrySwiper[0].slides[0].getAttribute('data-country-code');
        console.log(initialCode);
        
        window.dispatchEvent(new CustomEvent('region-focus', { 
            detail: { code: initialCode } 
        }));
      }
    }, 100);
  }
  // countrySwiper[i].init();

  const logoSlider = document.querySelectorAll('.logos-swiper');
  const logoSwiper = [];

  for (let i = 0; i < logoSlider.length; i++) {
    const slider = logoSlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-logos-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-logos');
      const prevBtn = parent.querySelector('.swiper-button-prev-logos');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-logos-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-logos-' + i);

      logoSwiper[i] = new Swiper('.swiper-container-logos-' + i, {
        // init: false, // Stop it from running immediately
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 5,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar-" + i,
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-logos-" + i,
          prevEl: ".swiper-button-prev-logos-" + i,
        },
      });
    }


  }

  const pillarSlider = document.querySelectorAll('.pillars-swiper');
  const pillarSwiper = [];

  for (let i = 0; i < pillarSlider.length; i++) {
    const slider = pillarSlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-pillars-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-pillars');
      const prevBtn = parent.querySelector('.swiper-button-prev-pillars');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-pillars-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-pillars-' + i);

      pillarSwiper[i] = new Swiper('.swiper-container-pillars-' + i, {
        // init: false, // Stop it from running immediately
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar-" + i,
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-pillars-" + i,
          prevEl: ".swiper-button-prev-pillars-" + i,
        },
      });
    }


  }

});


  const teamSlider = document.querySelectorAll('.team-swiper');
  const teamSwiper = [];

  for (let i = 0; i < teamSlider.length; i++) {
    const slider = teamSlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-team');
      const prevBtn = parent.querySelector('.swiper-button-prev-team');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-team-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-team-' + i);

      teamSwiper[i] = new Swiper('.swiper-container-' + i, {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: slides,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar-" + i,
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-team-" + i,
          prevEl: ".swiper-button-prev-team-" + i,
        },
      });
    }
  }

document.querySelectorAll('.gform_footer').forEach(footer => {
    // 1. Make the footer look clickable
    footer.style.cursor = 'pointer';

    footer.addEventListener('click', function(e) {
        // 2. Find the submit button inside this specific footer
        const submitBtn = this.querySelector('input[type="submit"], button[type="submit"]');
        
        // 3. Prevent infinite loops: only click the button if the user 
        // didn't click the button itself
        if (submitBtn && e.target !== submitBtn) {
            submitBtn.click();
        }
    });
});

Alpine.data('shareComponent', (data) => ({
    copied: false,
    copyUrl(passedURL) {
      let url;
      if(passedURL){
        // console.log(passedURL);
        url = passedURL;
      } else {
        url = window.location.href;
        // console.log(url);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => this.showCopied())
          .catch(() => this.fallbackCopy(url));
      } else {
        this.fallbackCopy(url);
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.showCopied();
      } catch (err) {
        alert('Copy failed. Please copy manually.');
      }
      document.body.removeChild(input);
    },
    showCopied() {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    }
}));

Alpine.data('map', () => ({
    activeRegion: null,

    // Helper to check for desktop
    isDesktop() {
        return window.innerWidth >= 640;
    },

    // Logic for hovering (Desktop only)
    handleMouseEnter(code) {
        if (this.isDesktop()) {
            this.activeRegion = code;
        }
    },

    handleMouseLeave() {
        if (this.isDesktop()) {
            this.activeRegion = null;
        }
    },

    // Logic for Swiper focus (Mobile only)
    handleMobileFocus(event) {
        // event.detail.code comes from your window.dispatchEvent in Swiper
        if (!this.isDesktop()) {
            this.activeRegion = event.detail.code;
        }
    }
}));
 
window.Alpine = Alpine
Alpine.start()